import {
	mapGetters,
	mapActions
} from 'vuex';

import PageBar from '@/components/page-bar/page-bar';
import PlanningFilter from '@/domains/lessons/planning-filter/main';
import Planning from '@/domains/lessons/planning/main';

import store from './store';

export default {
	...store,
	name: 'LessonPlanningPage',
	data: () => ({
		onlyPending: false
	}),
	computed: {
		...mapGetters([
			'schoolClassLessonPlan'
		])
	},
	components: {
		PageBar,
		PlanningFilter,
		Planning
	},
	methods: {
		...mapActions([
			'setBreadcrumb',
			'putSchoolClassLessonPlan'
		])
	},
	created() {

		this.setBreadcrumb([{
			text: 'Administrativo'
		}, {
			text: 'Planejamento de aula'
		}]);

	}
};



// WEBPACK FOOTER //
// ./sources/app/lesson-planning/index.js